<template>
  <v-menu
    v-model="menu"
    offset-y
    left
    transition="slide-y-transition"
    min-width="20%"
    max-width="30%"
    :nudge-width="200"
  >
    <template #activator="{ on: menuOn, attrs: menuAttrs }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-btn
            v-bind="{ ...defaultAttrs, ...menuAttrs, ...tooltipAttrs, ...$attrs }"
            v-on="{ ...menuOn, ...tooltipOn, ...$listeners }"
            @click.stop="toggleNotificationMenu"
          >
            <v-badge
              :content="items.length"
              :value="items.length"
              color="blue"
              overlap
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span v-if="tooltip">{{ tooltip }}</span>
      </v-tooltip>
    </template>

    <avs-card
      cardClass="rounded-0"
      noTitle
    >
      <template v-slot:content>
        <div
          v-if="!isLoading"
          class="d-flex justify-space-between"
        >
          <v-btn
            class="flex-grow-1"
            color="secondary"
            text
            :to="{ name: 'NotificationsPage' }"
          >
            <span class="font-weight-bold">
              {{ $t("actions.see", { entity: $t("commons.all", { entity: "" }).toLowerCase() }) }}
            </span>
          </v-btn>

          <avs-button
            fab
            iconI="mdi-refresh"
            icon
            label
            small
            color="secondary"
            :spantext="$t('refresh')"
            @click.stop="fetchNotifications()"
          />
        </div>
        <v-card-text
          v-if="items.length > 0"
          style="height: auto; max-height: 300px; overflow-y: scroll"
        >
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
            >
              <v-list-item-content>
                <div class="d-flex flex-column">
                  <span class="primary--text font-weight-bold">{{ item.company }}</span>
                  <span class="secondary--text font-weight-medium">{{ item.project }}</span>
                  <div class="d-flex align-center">
                    <v-icon color="primary">
                      {{ item.icon }}
                    </v-icon>

                    <span class="ml-4 font-weight-medium"> {{ item.object }} : </span>
                    <span class="ml-2 secondary--text"> {{ item.name }} </span>
                  </div>
                  <v-divider class="mt-2"></v-divider>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text
          class="d-flex justify-center text-caption"
          v-else
        >
          {{ $t("messages.information.no_notification") }}
        </v-card-text>
      </template>
    </avs-card>
  </v-menu>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"
import { toDatetime } from "@/utils/datetime"
export default {
  name: "NotificationButton",
  data() {
    return {
      defaultAttrs: {
        class: "text-caption font-weight-bold",
        icon: true
      },
      isLoading: false,
      menu: false,
      toNotificationPage: { name: "NotificationsPage" },
      tooltip: this.$tc("categories.notification.name", 2)
    }
  },
  computed: {
    items() {
      let notifications = this.$store.getters["app/getNewNotifications"]
      return notifications.map(e => {
        return {
          id: e.id,
          icon: this.getIcon(e.target.type),
          object: e.target.type,
          company: e.target.company,
          project: e.target.project.name,
          name: e.target.name,
          datetime: e.target.date
        }
      })
    }
  },
  methods: {
    toDatetime,
    getTheme,
    async fetchNotifications() {
      return this.$store.dispatch("app/fetchNotifications")
    },
    async updateNotifications() {
      return this.$store.dispatch("app/updateNotifications")
    },
    toggleNotificationMenu() {
      this.menu = !this.menu
    },
    getIcon(type) {
      if (type === "Inspection") {
        return "mdi-magnify"
      } else if (type === "Project") {
        return "mdi-airplane-takeoff"
      } else if (type === "Task") {
        return "mdi-clock-start"
      } else if (type === "NonConformity") {
        return "mdi-clipboard-alert-outline"
      } else {
        return ""
      }
    }
  }
}
</script>
